import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscriber } from 'rxjs';
import { ApiServiceService } from '../api-service.service';
import { SharedValidators } from '../shared/validators/shared-validators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatSuffix,
    MatPrefix,
    NgxPaginationModule,
  ],
})
export class ProfilePageComponent implements OnInit {
  private formSubmitAttempt = false;

  myimage = '';
  date = new Date();
  errormessage = '';

  email = '';
  showCurrentPassword = false;
  showNewPassword = false;

  userPermission = [];
  loggedId = '';

  userProfileForm: FormGroup = this.formBuilder.group({});
  userChangePasswordForm: FormGroup = this.formBuilder.group({});

  UserProfileUpdate = false;
  userProfileView = false;

  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.setProfileForm();
    this.checkPermission();
    if (this.userProfileView) {
      this.prePopulation(this.loggedId);
    }
  }

  checkPermission() {
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.date = new Date();

    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'User Profile' && element.update === true) {
          this.UserProfileUpdate = true;
        }
        if (element.pageName === 'User Profile' && element.view === true) {
          this.userProfileView = true;
        }
        if (element.pageName === 'User Profile' && element.view === false) {
          this.navigateBack();
        }
      }
    );
  }

  setProfileForm() {
    this.userProfileForm = this.formBuilder.group({
      firstName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      lastName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      mobileNumber: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.mobileNumberValidation,
      ]),
      userEmail: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.validEmail,
      ]),
      userRole: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      userRefId: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      country: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
      addressState: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      customerName: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      status: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      Image: '',
    });
    this.email = this.apiMicroservice.decryptData(
      sessionStorage.getItem('email') || ''
    );
    this.userChangePasswordForm = this.formBuilder.group({
      currentpassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
      password: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
    });
    this.myimage = '../../assets/profile.png';
  }

  prePopulation(id: string) {
    this.spinner.show();
    this.apiMicroservice.getSingleUser(id).subscribe((res) => {
      this.date = new Date();
      const data = res.data[0];
      if (res.status) {
        this.userProfileForm = this.formBuilder.group({
          firstName: new FormControl(data.firstName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          lastName: new FormControl(data.lastName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          mobileNumber: new FormControl(data.mobileNumber, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.mobileNumberValidation,
          ]),
          userEmail: new FormControl(data.customerEmail, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.validEmail,
          ]),
          userRole: new FormControl(data.userRole, Validators.required),
          addressState: new FormControl(data.addressState, [
            SharedValidators.requiredAndNoEmptySpaces,
            Validators.pattern('[A-Za-z/S/]+$'),
            Validators.maxLength(30),
          ]),
          country: new FormControl(data.country, [
            SharedValidators.requiredAndNoEmptySpaces,
            Validators.pattern('[A-Za-z/S/]+$'),
            Validators.maxLength(10),
          ]),
          status: new FormControl(data.status, Validators.required),
          customerName: new FormControl(data.customerName, Validators.required),
          Image: '',
          userRefId: data.userRefId,
          id: id,
          // "createdAt": this.date,
          updatedAt: this.date,
        });
        this.myimage = data.Image
          ? data.Image
          : '../../assets/source_right.png';
      } else {
        this.apiMicroservice.openSnackbar(res.message);
      }
      this.spinner.hide();
    });
  }

  validateFormUpdate() {
    if (this.userProfileForm.invalid) {
      this.userProfileForm.get('firstName')?.markAllAsTouched();
      this.userProfileForm.get('lastName')?.markAllAsTouched();
      this.userProfileForm.get('userEmail')?.markAllAsTouched();
      this.userProfileForm.get('mobileNumber')?.markAllAsTouched();
      this.userProfileForm.get('country')?.markAllAsTouched();
      this.userProfileForm.get('addressState')?.markAllAsTouched();
      return;
    } else {
      this.updateUser();
    }
  }

  updateUser() {
    this.spinner.show();
    const payload = this.userProfileForm.value;
    sessionStorage.setItem(
      'userName',
      this.apiMicroservice.encryptData(payload.firstName)
    );
    sessionStorage.setItem(
      'email',
      this.apiMicroservice.encryptData(payload.userEmail)
    );
    sessionStorage.setItem(
      'userFullName',
      this.apiMicroservice.encryptData(
        `${payload.firstName} ${payload.lastName}`
      )
    );
    payload.Image = this.myimage;
    this.apiMicroservice.updateUser(payload).subscribe((res) => {
      if (res.status) {
        this.apiMicroservice.openSnackbar(res.message);
      } else {
        this.apiMicroservice.openSnackbar(res.message);
      }
      this.spinner.hide();
      this.ngOnInit();
    });
  }

  validateFormPasswordUpdate() {
    if (this.userChangePasswordForm.invalid) {
      this.userChangePasswordForm.get('currentpassword')?.markAsTouched();
      this.userChangePasswordForm.get('password')?.markAsTouched();
      return;
    } else {
      this.ChangePassword();
    }
  }

  ChangePassword() {
    if (confirm('Are you Sure?')) {
      if (
        this.userChangePasswordForm.value.currentpassword ===
        this.userChangePasswordForm.value.password
      ) {
        this.apiMicroservice.openSnackbar(
          'Current Password cannot be same as New Password.'
        );
      } else {
        const payload = {
          currentpassword: this.userChangePasswordForm.value.currentpassword,
          password: this.userChangePasswordForm.value.password,
          customerEmail: this.email,
        };
        this.apiMicroservice.userChangePassword(payload).subscribe({
          next: (res) => {
            if (res.status) {
              this.closeModal();
              this.apiMicroservice.openSnackbar(res.message);
            } else {
              this.closeModal();
              this.apiMicroservice.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            const example = ERROR.error.message;
            this.apiMicroservice.openSnackbar(example);
          },
        });
      }
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.userChangePasswordForm.get(field)?.valid &&
        this.userChangePasswordForm.get(field)?.touched) ||
      (this.userChangePasswordForm.get(field)?.untouched &&
        this.formSubmitAttempt)
    );
  }

  changePass() {
    document
      .getElementById('changePassword')
      ?.parentElement?.classList.add('active');
  }

  closeModal() {
    document
      .getElementById('changePassword')
      ?.parentElement?.classList.remove('active');
    this.userChangePasswordForm = this.formBuilder.group({
      currentpassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
      password: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
    });
  }

  onChange($event: Event) {
    $event.stopPropagation(); // Stops event from bubbling up
    $event.preventDefault(); // Prevents any default behavior

    const file = ($event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const fileName = file.name;
    if (file.size >= 2 * 1024 * 1024) {
      this.apiMicroservice.openSnackbar('Max upload size allowed is 2mb');
    } else {
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (
        ext.toLowerCase() === 'png' ||
        ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'jpeg'
      ) {
        this.convertToBase64(file);
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<string>) => {
      this.readFile(file, subscriber);
    });
    observable.subscribe((d) => {
      this.myimage = d;
      //
    });
  }

  readFile(file: File, subscriber: Subscriber<string | null>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const result = fileReader.result;
      if (typeof result === 'string') {
        // Type guard
        subscriber.next(result);
      } else {
        subscriber.error(new Error('File could not be read as a string.'));
      }
      subscriber.complete();
    };

    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
